var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{staticClass:"logo",attrs:{"src":"img/logo.jpg"}}),_c('img',{staticClass:"gif",attrs:{"src":"img/jzz.gif"}}),_c('span',[_vm._v("加载中~")])])])
}]

export { render, staticRenderFns }